import { Factory } from 'miragejs';

export default Factory.extend({
  notificationEmails: () => [],
  globalAdminNotificationsEnabled: true,
  locationAdminNotificationsEnabled: true,
});
